import { CreateObjectStepId } from 'entities/kyrgyzstan/model/create-object'

import { CreateObjectStepConfig, CreateObjectStepDefinition } from './types'

export const createObjectStepDefinitions: CreateObjectStepDefinition[] = [
  {
    id: CreateObjectStepId.ObjectType,
  },
  {
    id: CreateObjectStepId.Photos,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.Address,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.AddressMap,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.Amenities,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.AdditionalAmenities,
    previousStepId: CreateObjectStepId.Amenities,
    nextStepId: CreateObjectStepId.Amenities,
    isAuxiliary: true,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.Description,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.Price,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.Conditions,
    requiresDraft: true,
  },
  {
    id: CreateObjectStepId.Confirmation,
    requiresDraft: true,
  },
]

export const createObjectStepOrder: CreateObjectStepId[] =
  createObjectStepDefinitions
    .filter((step) => !step.isAuxiliary)
    .map((step) => step.id)

export const createObjectStepTotal = createObjectStepOrder.length

const getCreateObjectStepIndex = (step: CreateObjectStepDefinition): number => {
  const stepIdForIndex =
    step.isAuxiliary && step.previousStepId ? step.previousStepId : step.id

  return createObjectStepOrder.indexOf(stepIdForIndex) + 1
}

export const createObjectSteps: CreateObjectStepConfig[] =
  createObjectStepDefinitions.map((step) => {
    const index = getCreateObjectStepIndex(step)
    const mainStepIndex = createObjectStepOrder.indexOf(step.id)

    return {
      ...step,
      index,
      previousStepId:
        step.previousStepId || createObjectStepOrder[mainStepIndex - 1],
      nextStepId: step.nextStepId || createObjectStepOrder[mainStepIndex + 1],
    }
  })
